module.exports = __webpack_public_path__ + "static/media/MSC.65764824.png";